import { useState, useEffect, useCallback } from 'react';

// eslint-disable-next-line
// @ts-ignore
function useSwipeScroll({
  sliderRef,
  reliants = [],
  momentumVelocity = 0.9
}) {
  const [hasSwiped, setHasSwiped] = useState(false);
  const init = useCallback(() => {
    const slider = sliderRef.current;
    if (!slider) return;
    let isDown = false;
    // eslint-disable-next-line
    // @ts-ignore
    let startX;
    // eslint-disable-next-line
    // @ts-ignore
    let scrollLeft;
    // eslint-disable-next-line
    slider.addEventListener('mousedown', (e: any) => {
      isDown = true;
      slider.classList.add('active');
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
      cancelMomentumTracking();
    });
    slider.addEventListener('mouseleave', () => {
      isDown = false;
      slider.classList.remove('active');
    });
    slider.addEventListener('mouseup', () => {
      isDown = false;
      slider.classList.remove('active');
      beginMomentumTracking();
      setTimeout(() => setHasSwiped(false), 0);
    });
    // eslint-disable-next-line
    slider.addEventListener('mousemove', (e_0: any) => {
      if (!isDown) return;
      e_0.preventDefault();
      const x = e_0.pageX - slider.offsetLeft;
      // eslint-disable-next-line
      // @ts-ignore
      const walk = x - startX; //scroll-fast
      let prevScrollLeft = slider.scrollLeft;
      // eslint-disable-next-line
      // @ts-ignore
      slider.scrollLeft = scrollLeft - walk;
      velX = slider.scrollLeft - prevScrollLeft;
      if (slider.scrollLeft - prevScrollLeft && !hasSwiped) {
        setHasSwiped(true);
      }
    });

    // Momentum
    let velX = 0;
    // eslint-disable-next-line
    // @ts-ignore
    let momentumID;
    // eslint-disable-next-line
    slider.addEventListener('wheel', (e_1: any) => {
      cancelMomentumTracking();
    });
    function beginMomentumTracking() {
      cancelMomentumTracking();
      momentumID = requestAnimationFrame(momentumLoop);
    }
    function cancelMomentumTracking() {
      // eslint-disable-next-line
      // @ts-ignore
      cancelAnimationFrame(momentumID);
    }
    function momentumLoop() {
      slider.scrollLeft += velX;
      velX *= momentumVelocity;
      if (Math.abs(velX) > 0.5) {
        momentumID = requestAnimationFrame(momentumLoop);
      }
    }
    // eslint-disable-next-line
  }, [sliderRef, momentumVelocity]);
  useEffect(() => {
    init();
    // eslint-disable-next-line
  }, [...reliants, init]);
  return {
    hasSwiped
  };
}
export default useSwipeScroll;